import { Injectable, inject } from '@angular/core'
import {
    AbstractControl,
    FormGroup,
    NonNullableFormBuilder,
    Validators,
} from '@angular/forms'
import { LoginInput } from '@mattrika/benefit-model'

@Injectable({
    providedIn: 'root',
})
export class LoginFormService {
    private fb = inject(NonNullableFormBuilder)
    form = this.buildForm()

    buildForm(): FormGroup {
        const { required, email } = Validators
        return this.fb.group({
            identifier: ['', [required, email]],
            password: ['', [required]],
        })
    }

    get identifier(): AbstractControl | null {
        return this.form.get('identifier')
    }

    get password(): AbstractControl | null {
        return this.form.get('password')
    }

    getValue(): LoginInput {
        return this.form.getRawValue() as LoginInput
    }

    patchForm(data: Partial<LoginInput>) {
        this.form.patchValue(data)
    }
}
